import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { CardMedia, CardActionArea } from '@material-ui/core';

import InstorexLogo from '../../../assets/images/video1.jpg';

const useStyles = makeStyles({
  root: {
    width: 214,
    height: 215,
    textAlign: 'left',
  },
  media: {
    height: 90,
    margin: 15,
  },
});


export default function OutlinedCard({ fileImage, filename, fileType }) {
  const classes = useStyles();

  return (
    <>
      {filename && fileType ? (
        <>
        <Card className={classes.root} variant="outlined">
          <CardActionArea>
            <CardMedia className={classes.media}
              image={fileImage ? fileImage : InstorexLogo} title={filename} />
            <CardContent>
              <Typography gutterBottom variant="body2" component="h2">
                  Filename:{filename}
              </Typography>
              <Typography gutterBottom variant="body2" color="textSecondary" component="h2">
                  Type:{fileType}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
        </>
      ) : ''} 
    </>
  );
}
